import { environment as localEnvironment } from './lib/environments/environment';
import { environment as devEnvironment } from './lib/environments/environment.dev';
import { environment as prodEnvironment } from './lib/environments/environment.prod';

// Export the environments
export const environment = {
  local: localEnvironment,
  production: prodEnvironment,
  development: devEnvironment,
};

// Alternatively, you can export them separately if needed
export { devEnvironment, prodEnvironment, localEnvironment };

// Local API override (edit local-api.config.ts to route services at localhost while testing)
export {
  LOCAL_API,
  resolveLocalBaseUrl,
  resolveLocalPath,
} from './lib/local-api.config';
export type {
  LocalServiceOverride,
  LocalPathRewrite,
} from './lib/local-api.config';
